import React from "react";
import {Alert, Button, CircularProgress, Grid, Typography} from "@mui/material";
import {Check, Close} from "@mui/icons-material";

export const APPROVAL_DIALOG_TITLE_ID = 'approval-dialog-title';

type Props = {
    className?: string
    title: string

    saveTitle: string
    onSave: () => void
    canSave: boolean

    loading?: boolean

    onClose: () => void

    error?: string

    children?: React.ReactNode
};
export const ApprovalDialog: React.FC<Props> = ({
                                                    className,
                                                    title,
                                                    saveTitle,
                                                    onSave,
                                                    canSave,
                                                    loading,
                                                    onClose,
                                                    error,
                                                    children
                                                }) =>
    <Grid container direction="column" className={"edit-model-component" + (className ? ' ' + className : '')}>
        <Grid container>
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={3}
                size={8}>
                <Grid>
                    <Typography id={APPROVAL_DIALOG_TITLE_ID} variant="h5">
                        {title}
                    </Typography>
                </Grid>
                <Grid>
                    {children}
                </Grid>
            </Grid>
            <Grid size={2}/>
            <Grid
                alignItems="stretch"
                spacing={3}
                container
                direction="column"
                justifyContent="space-between"
                size={2}>
                <Grid>
                    <Button
                        fullWidth
                        className="btn-red"
                        startIcon={<Close/>}
                        onClick={onClose}
                        variant="outlined"
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid>
                    <Button
                        disabled={!canSave}
                        fullWidth
                        startIcon={loading === true ? <CircularProgress size={14}/> : <Check/>}
                        onClick={onSave}
                        variant="outlined"
                    >
                        {saveTitle}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
        {error && <Grid className="mt-3">
            <Alert severity="error">{error}</Alert>
        </Grid>}
    </Grid>

